module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Classic vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Light and luscious, this vanilla sponge recipe will never fail to produce a great sponge base for the most fabulous decorations. If you fancy a change for a more zingy flavour, simply follow the suggestions for a citrus version.")]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("You will need… makes about 12")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("125g (4"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz) margarine, softened")]), _vm._v(" "), _c('li', [_vm._v("125g (4"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz) caster (superfine) sugar")]), _vm._v(" "), _c('li', [_vm._v("1 tsp (5ml) vanilla extract")]), _vm._v(" "), _c('li', [_vm._v("2 eggs (medium or large), lightly beaten")]), _vm._v(" "), _c('li', [_vm._v("125g (4"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz) self-raising (-rising) flour")]), _vm._v(" "), _c('li', [_vm._v("2 tbsp (30ml) milk")])]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Preheat the oven to 200°C/fan 180°C/400°F/Gas Mark 6. Line your muffin tray (pan) with muffin cases (liners) and set to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Place the margarine, sugar and vanilla extract in the bowl of an electric stand mixer and cream together until light and fluffy.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Add the eggs gradually and then sift the flour into the mixture and combine on a low speed. Add the milk to make a smooth dropping consistency.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Spoon the mixture evenly into the cases or fill a large disposable plastic piping (pastry) bag with the batter, snip off the end and pipe it into the muffin cases.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Bake for 25–28 minutes, or until risen and springy to the touch. Cool on a wire rack.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("To")]), _vm._v(" vary the flavour of the sponge, for lemon or orange, replace the vanilla extract with a teaspoon of lemon or orange oil. For a more zingy citrus taste, add the finely grated zest of one washed unwaxed lemon or orange. For a chocolate chip option, add 100g (3"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz) dark (semisweet or bittersweet) or milk chocolate chips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/120314_BMIY_210_fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67ee3b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c04.vue
// module id = 75
// module chunks = 0